<template>
  <div
    class="integrate-search-history"
  >
    <!-- 左侧导航 -->
    <HistoryQueryLeftNav/>

    <router-view :key="currentPath" />
  </div>
</template>

<script>
import $ from 'jquery';
import HistoryQueryLeftNav from '../components/HistoryQueryLeftNav/HistoryQueryLeftNav';
import { HistoryQueryClassName } from '../config/config';


export default {
    beforeRouteEnter(to, from, next) {
        $('.analytics-website').addClass(HistoryQueryClassName);
        next();
    },
    beforeRouteLeave(to, from, next) {
        $('.analytics-website').removeClass(HistoryQueryClassName);
        next();
    },
    components: {
        HistoryQueryLeftNav
    },
    data() {
        return {
            currentPath: ''
        };
    },
    computed: {
    },
    methods: {
    }
};
</script>

<style lang="scss">
body{
    overflow-y: hidden;
  * {
        outline: 0;
    }
}
.analytics-website__search-history {
  min-width: 1200px;
  height: 100%;
  overflow-y: hidden;
  .fundation-app {
    min-width: auto;
  }
}
.integrate-search-history {
  display: flex;
  width: 100%;
  background: #fafbfc;
  *{
      outline: 0;
  }
}
.el-tooltip__popper.is-dark {
    background: #344563  !important;
}
</style>
